import { PayloadAction, createSlice       } from '@reduxjs/toolkit';

import { RadioGroupItem                   } from 'src/components/common/radio-group';

import { RootState                        } from 'src/store';


const SLICE_NAME = 'main:product-type-dialog';

export interface MainProductTypeDialogState {
    isOpened: boolean;
    productTypeRadioItem: RadioGroupItem
}

const initialState: MainProductTypeDialogState = {
    isOpened: false,
    productTypeRadioItem: {
        id: '1',
        label: 'Лист',
        iconKey: 'list',
    },
}

export const mainProductTypeDialogSlice = createSlice({
    name: SLICE_NAME, 
    initialState: { ...initialState },
    reducers: {
        initDialog: (state, action: PayloadAction<boolean>) => {
            state.isOpened = action.payload
        },
        setIsOpened: (state) => {
            state.isOpened = !state.isOpened
        },
        setProductTypeRadioItem: (state, action: PayloadAction<RadioGroupItem>) => {
            state.productTypeRadioItem = action.payload
        }
    }
})

const selectIsOpened = (state: RootState) => state.mainProductTypeDialog.isOpened;
const selectProductTypeRadioItem = (state: RootState) => state.mainProductTypeDialog.productTypeRadioItem;

export const mainProductTypeDialogSelectors = {
    selectIsOpened,
    selectProductTypeRadioItem,
}

export const mainProductTypeDialogActions = mainProductTypeDialogSlice.actions;

export default mainProductTypeDialogSlice.reducer;